var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.minPrice)?_c('div',{staticClass:"price-status-bar"},[_c('div',{staticClass:"price-status-bar__bg",style:({ width: `${_vm.percent}%` })}),_c('RemixIconComponent',{attrs:{"category":"system","name":"information-fill"}}),_c('span',[_vm._v("Минимальная сумма заказа для доставки: "+_vm._s(_vm.minPrice)+" ₽")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }